export type SubscriptionTier = 'free' | 'weekly' | 'monthly' | 'lifetime';

/** Maps DB / localStorage legacy tier strings to app tiers (weekly | monthly | lifetime). */
export function appSubscriptionTierFromStored(
  stored: string | null | undefined
): SubscriptionTier {
  if (!stored) return 'free';
  if (stored === 'weekly' || stored === 'monthly' || stored === 'lifetime') return stored;
  if (stored === 'pro' || stored === 'go') return 'monthly';
  return 'free';
}
